// extracted by mini-css-extract-plugin
module.exports = {"content":"RegistUser_content__2aQOm"};